import { PromocodeHistoryDisplayByTypeEnum } from '__generatedTypes__/globalTypes'

export type DateOption = {
  id: string
  title: string
  displayBy: PromocodeHistoryDisplayByTypeEnum
}

export type Filters = {
  from: Date
  to: Date
}

export enum DateOptionsEnum {
  Today = 'today',
  Yesterday = 'yesterday',
  ThisMonth = 'thisMonth',
  LastMonth = 'lastMonth',
  ThisYear = 'thisYear',
  LastYear = 'lastYear',
  LastTwoMonths = 'lastTwoMonths',
  Last30days = 'last30days',
  Last90days = 'last90days',
  Last180days = 'last180days',
  Last365days = 'last365days',
  Lifetime = 'lifetime',
  CustomDateRange = 'customDateRange',
}

export const DATE_OPTIONS: DateOption[] = [
  {
    id: DateOptionsEnum.ThisMonth,
    title: 'This Month',
    displayBy: PromocodeHistoryDisplayByTypeEnum.DAYS,
  },
  {
    id: DateOptionsEnum.LastMonth,
    title: 'Last Month',
    displayBy: PromocodeHistoryDisplayByTypeEnum.DAYS,
  },
  {
    id: DateOptionsEnum.LastTwoMonths,
    title: 'Last Two Months',
    displayBy: PromocodeHistoryDisplayByTypeEnum.MONTHS,
  },
  {
    id: DateOptionsEnum.Last30days,
    title: 'Last 30 days',
    displayBy: PromocodeHistoryDisplayByTypeEnum.DAYS,
  },
  {
    id: DateOptionsEnum.Last90days,
    title: 'Last 90 days',
    displayBy: PromocodeHistoryDisplayByTypeEnum.MONTHS,
  },
  {
    id: DateOptionsEnum.Last180days,
    title: 'Last 180 days',
    displayBy: PromocodeHistoryDisplayByTypeEnum.MONTHS,
  },
  {
    id: DateOptionsEnum.Last365days,
    title: 'Last 365 days',
    displayBy: PromocodeHistoryDisplayByTypeEnum.MONTHS,
  },
  {
    id: DateOptionsEnum.Lifetime,
    title: 'Lifetime',
    displayBy: PromocodeHistoryDisplayByTypeEnum.MONTHS,
  },
  {
    id: DateOptionsEnum.CustomDateRange,
    title: 'Custom Date Range',
    displayBy: PromocodeHistoryDisplayByTypeEnum.MONTHS,
  },
]
